<template>
  <section class="notice">
    <div class="notice-header">
      <com-tabs
        @change="changeTab"
        :list="statisticsInfo.obj.tabs6"
        class="notice-tabs"
        :defaultTab="activeTab"
      >
        <template v-slot:text="{ obj }">
          <div
            :class="{ activeTab: activeTab == obj.key }"
            class="notice-tabs-item"
          >
            {{ obj.name }}
          </div>
        </template>
      </com-tabs>
    </div>

    <div class="notice-content">
      <com-term0 
        v-show="activeTab == 0" 
        @pre="handlePrePage"
        @next="handleNextPage" />
       <com-term1 
        v-show="activeTab == 1" 
        @pre="handlePrePage"
        @next="handleNextPage" />
     
    </div>
  </section>
</template>
<script>
import mock from "@/utils/mock";
import comTabs from "@/components/comTabs";
import comTerm0 from "./details/comTerm0.vue";
import comTerm1 from "./details/comTerm1.vue";
export default {
  name: "comNotice",
  components: {
    comTabs,
    comTerm0,
    comTerm1,
   
  },
  props: {},
  computed: {},
  watch: {},
  data() {
    return {
      activeTab: 0,
      statisticsInfo: mock.statistics.statistics.viewInfo,
      statisticsInit: mock.statistics.statistics.init,
    };
  },
  mounted() {},
  methods: {
    changeTab(x, y) {
      this.activeTab = x;
    },
    handlePrePage() {
      if(this.activeTab ==0){
        this.$message({
          type:"error",
          message:"当前已为第一章"
        })
      }else{
        this.activeTab -= 1;
      }
      
    },
    handleNextPage() {
      if(this.activeTab ==6){
        this.$message({
          type:"error",
          message:"当前已为最后一章"
        })
      }else{
        this.activeTab += 1;
      }
      
    },
  },
};
</script>
<style lang="scss" scoped>
.notice {
  margin-top: 20px;
  &-header {
    display: flex;
    justify-content: space-between;
    > span {
      cursor: pointer;
      padding: 6px 20px;
      border-radius: 5px;
    }
    .btn1 {
      background-color: #fff;
      border: 1px solid #d7d4d4;
      color: #333;
    }
    .btn2 {
      background-color: #2f82ff;
      border: 1px solid #2f82ff;
      color: #fff;
    }
  }
  &-tabs {
    width: 800px !important;
    display: flex;
    flex-direction: column;
    margin-right: 18px;

    &-item {
      text-align: center;
      font-size: 14px;
      color: #333;
      line-height: 30px;
      cursor: pointer;
    }
    .activeTab {
      color: #2f82ff;
      font-weight: bold;
      border-bottom: 2px solid #2f82ff;
    }
  }
  &-content {
    margin-top: 22px;
  }
}
.notice /deep/ .tabs {
        margin-left: 20px;
  > div {
    flex: none;
    margin-right: 40px;
  }
}
</style>
